/**
 * Comprometido total do projeto = soma de TODAS as raízes.
 *
 * `committedTotal` vem do back-end como uma linha por raiz (`commited_totals`), e
 * obra agregada tem uma raiz por obra do ERP. Os cards de verba disponível liam
 * `committedTotal[0]` — só a primeira — enquanto o card "Total comprometido" ao
 * lado já somava todas. A verba disponível saía inflada pela diferença:
 *
 *   Prívia Residence   correta R$ 1.697.868,16   exibida R$ 2.714.536,86
 *   Voss Residence     correta R$ 16.370.008,46  exibida R$ 17.911.251,50
 *   WS GERAL           correta R$ 1.370.868,77   exibida R$ 2.014.977,21
 *
 * É o par no front-end do `sumCommittedTotals` que o back-end já usa.
 */
export const sumCommitted = (committedDocs) =>
  (committedDocs ?? []).reduce((total, doc) => {
    // Coerção defensiva: há `value` não finito persistido em produção, e uma soma
    // crua devolveria NaN — que o formatter converte em "0,00" e a tela apresenta
    // como se fosse comprometido zero.
    const raw = doc?.value;
    const value = typeof raw === "number" ? raw : Number(raw);
    return total + (Number.isFinite(value) ? value : 0);
  }, 0);
